export default __webpack_public_path__ + "static/media/uploader-abbottLibre-2.b0fe7c60.png";